const styles = {
  receiptProductItemTitleStyle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignSelf: "stretch",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  receiptProductItemTitleDefaultStyle: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    alignSelf: "stretch",
  },
  productItem: {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
  },
  container: {
    padding: "8px 16px",
  },
  title: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "20px",
    alignSelf: "stretch",
  },
  itemName: {
    maxWidth: "233px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

export default styles;
